// Local dev serves this same build from whatever host can reach this
// machine — localhost/127.0.0.1 in a browser, 10.0.2.2 from the Android
// emulator's WebView, or a LAN IP when testing from a physical device. A
// locally configured backend URL only ever varies by port for these, so if
// the page itself loaded through a recognized local host, swap the
// configured URL's host for the page's own host — the page already proved
// that host can reach this machine.
//
// Deployed URLs (heimdal-api.dev.zippedi.com, etc.) are real subdomains, not
// local aliases, so they never match LOCAL_HOSTS and are returned untouched.
// Reuses REACT_APP_APPCHECK_DEBUG_HOSTS as the single source of truth for
// "what counts as local" — the same list App Check debug mode already keys
// off in firebase.js.
const LOCAL_HOSTS = (process.env.REACT_APP_APPCHECK_DEBUG_HOSTS || '')
  .split(',')
  .map(host => host.trim())
  .filter(Boolean);

export function resolveLocalBackendUrl(configuredUrl) {
  if (typeof window === 'undefined' || !configuredUrl) {
    return configuredUrl;
  }

  let url;
  try {
    url = new URL(configuredUrl);
  } catch {
    return configuredUrl;
  }

  if (!LOCAL_HOSTS.includes(url.hostname)) {
    return configuredUrl;
  }

  url.hostname = window.location.hostname;
  return url.toString().replace(/\/$/, '');
}
